import {observable, action} from 'mobx';
import _ from 'lodash';

class FormStore {
  @observable data = {};
  @observable error = {};
  @observable errors = [];
  @observable validationErrors = {};

  constructor(parentStore) {
    this.parentStore = parentStore;
  }

  @action
  handlerInput = (event) => {
    if (event.target && event.target.name && event.target.checked) {
      _.set(this.data, event.target.name, event.target.checked);
    } else if (event.target && event.target.name && event.target.value !== undefined) {
      const v = event.target.name.endsWith('variants') ? event.target.value.split(',') : event.target.value;
      _.set(this.data, event.target.name, v);
    }
    if(event.target.name in this.validationErrors && (!!event.target.value || !!event.target.checked)){
      delete this.validationErrors[event.target.name];
    }
  };

  @action
  handlerTextarea = (event) => {
    if (event.target && event.target.name && event.target.value !== undefined) {
      console.log(event.target.value);
      const v = event.target.name.endsWith('variants') ? event.target.value.split(',') : event.target.value;
      _.set(this.data, event.target.name, v);
    }
  };

  @action
  handlerCheckbox = (event) => {
    _.set(this.data, event.target.name, event.target.checked);
  };

  @action
  handlerCheckboxes = (event) => {
    const currentValue = this.getField(event.target.name, []);
    if (event.target.checked === true && !currentValue.includes(event.target.value)) {
      currentValue.push(event.target.value);
      _.set(this.data, event.target.name, currentValue);
    } else if (event.target.checked === false && currentValue.includes(event.target.value)) {
      _.remove(currentValue, function(str) {
        return str === event.target.value;
      });

      _.set(this.data, event.target.name, currentValue);
    }
  };

  @action
  handlerSelect = (v) => {
    _.set(this.data, 'navigation_difficulty', v);
  };

  @action
  handlerReactSelect = (name) => (option) => {
    this.data[name] = option.value;
  };

  @action
  handlerDateInput = (name) => (date) => {
    this.data[name] = date;
  };

  @action
  handlerTimestamp = (name) => (date) => {
    if (date) {
      this.data[name] = date.getTime();
    }
  };

  @action
  handlerRating = (name) => (value) => {
    _.set(this.data, name, value);
  };

  getField(name, defaultValue) {
    return _.get(this.data, name, defaultValue);
  }

  arrayContains(name, value) {
    return _.get(this.data, name, []).includes(value);
  }

  @action
  setField(name, value) {
    if(name in this.validationErrors && !!value){
      delete this.validationErrors[name];
    }
    return _.set(this.data, name, value);
  }

  @action
  setData(data) {
    Object.keys(data).map((key) => {
      const value = data[key];
      if (typeof value === 'object' && !(value instanceof Array)) {
        Object.keys(value).map((k) => {
          const vl = value[k];
          _.set(this.data, key + '.' + k, vl);
        });
      } else {
        _.set(this.data, key, value);
      }
    });
  }

  addError(error) {
    this.errors = [error];
  }

  getErrors() {
    return this.errors;
  }

  getValidationError(name) {
    return _.get(this.validationErrors, name, undefined);
  }

  @action
  async isValid(schema) {
    let errors = await schema.validate(this.data, {abortEarly: false})
        .then(() => {
          return {};
        })
        .catch((err) => {
          let errors = {};
          if (err && err.inner) {
            err.inner.forEach((e) => {
              errors[e.path] = e.message;
            });
          }
          return errors;
        });
    this.validationErrors = errors;
    return Object.keys(this.validationErrors).length === 0;
  }

}

export default FormStore;
